import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/date-icon.svg'
import _imports_1 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-ffaa3248"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "search-main d-f bg-fff m-8 p-16" }
const _hoisted_3 = { class: "search-item d-f flex-d-c" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Payout Year", -1))
const _hoisted_5 = { class: "search-item d-f flex-d-c m-l-16" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Payout Month", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "search-item d-f flex-d-c m-l-16" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Payout Code", -1))
const _hoisted_10 = { class: "d-f justify-e flex-d-c m-l-16" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_12 = { class: "container bg-fff" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "Payment To Dealer")
], -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Approve Path")
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "Payment To MBAFC & MBLC")
], -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Approve Path")
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApproveSteps = _resolveComponent("ApproveSteps")!
  const _component_YearPicker = _resolveComponent("YearPicker")!
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_collapse_wrapper = _resolveComponent("collapse-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ApproveSteps, {
      visible: _ctx.approveVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.approveVisible) = $event)),
      data: _ctx.approveList
    }, null, 8, ["visible", "data"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_YearPicker, {
          value: _ctx.searchParams.payoutYear,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParams.payoutYear) = $event)),
          allowClear: false,
          placeholder: "Please select"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_a_month_picker, {
          value: _ctx.searchParams.payoutMonth,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParams.payoutMonth) = $event)),
          placeholder: "Please select",
          defaultPickerValue: _ctx.searchParams.payoutYear,
          format: "MMM"
        }, {
          suffixIcon: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["value", "defaultPickerValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_a_input, {
          value: _ctx.searchParams.payoutCode,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParams.payoutCode) = $event)),
          placeholder: "Filtered by Payout Code"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _withModifiers(_ctx.doSearch, ["stop"])
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_collapse_wrapper, { data: _ctx.tableDataDealer }, {
        header: _withCtx(() => [
          _hoisted_13
        ]),
        content: _withCtx(() => [
          _createVNode(_component_a_table, {
            class: "m-l-16 m-r-16 data-table",
            columns: _ctx.columnsDealer,
            dataSource: _ctx.tableDataDealer,
            rowKey: "id",
            scroll: {x: 1500},
            pagination: false,
            rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
          }, {
            payoutRound: _withCtx(({ text, record }) => [
              _createElementVNode("a", {
                onClick: _withModifiers(($event: any) => (_ctx.$router.push({ path: '/paymentApproveMgmt/dealerPayoutTrackingOverview', query: { payoutRound: record.payoutRound}})), ["prevent","stop"])
              }, _toDisplayString(text), 9, _hoisted_14)
            ]),
            payoutCode: _withCtx(({ record: {payoutCode} }) => [
              _createElementVNode("a", {
                onClick: _withModifiers(($event: any) => (_ctx.downloadDealerPayoutCodeFile(payoutCode)), ["prevent"])
              }, _toDisplayString(payoutCode), 9, _hoisted_15)
            ]),
            programNo: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousands(record.programNo)), 1)
            ]),
            dealerNo: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousands(record.dealerNo)), 1)
            ]),
            payoutAmountWVoat: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousandsAndTwoDecimal(record.payoutAmountWVoat)), 1)
            ]),
            payoutAmountWVat: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousandsAndTwoDecimal(record.payoutAmountWVat)), 1)
            ]),
            action: _withCtx(({ record }) => [
              _createVNode(_component_a_tooltip, null, {
                title: _withCtx(() => [
                  _hoisted_16
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "font_family icon-ApprovalPath m-l-20",
                    style: {"font-size":"24px"},
                    onClick: ($event: any) => (_ctx.approveClick(record, 'DEALER'))
                  }, null, 8, _hoisted_17)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["columns", "dataSource", "rowClassName"])
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_collapse_wrapper, { data: _ctx.tableDataMBAFCandMBLC }, {
        header: _withCtx(() => [
          _hoisted_18
        ]),
        content: _withCtx(() => [
          _createVNode(_component_a_table, {
            class: "m-l-16 m-r-16 data-table",
            columns: _ctx.columnsMBAFCandMBLC,
            dataSource: _ctx.tableDataMBAFCandMBLC,
            rowKey: "id",
            scroll: {x: 1300},
            pagination: false,
            rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
          }, {
            payoutRound: _withCtx(({ text }) => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            payoutCode: _withCtx(({ record: {payoutCode} }) => [
              _createElementVNode("a", {
                onClick: _withModifiers(($event: any) => (_ctx.downloadAFCPayoutCodeFile(payoutCode)), ["prevent"])
              }, _toDisplayString(payoutCode), 9, _hoisted_19)
            ]),
            programNo: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousands(record.programNo)), 1)
            ]),
            vinNo: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousands(record.vinNo)), 1)
            ]),
            payoutAmountWVat: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousandsAndTwoDecimal(record.payoutAmountWVat)), 1)
            ]),
            action: _withCtx(({ record }) => [
              _createVNode(_component_a_tooltip, null, {
                title: _withCtx(() => [
                  _hoisted_20
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "font_family icon-ApprovalPath m-l-20",
                    style: {"font-size":"24px"},
                    onClick: ($event: any) => (_ctx.approveClick(record, 'FL'))
                  }, null, 8, _hoisted_21)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["columns", "dataSource", "rowClassName"])
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ]))
}